import type { ExamV3ExamReservationConfiguration } from 'types/examV3ExamReservationSettings.type';
import { z } from 'zod';
import {
  fieldSchema,
  informationBlockSchema,
  mappedValueSchema,
} from '../../validation';

const locationSchema = z.object({
  room: mappedValueSchema.optional(),
  building: mappedValueSchema.optional(),
  campus: mappedValueSchema.optional(),
});

const examReservationSettingsSchema = z.object({
  examType: mappedValueSchema,
  examLabel: mappedValueSchema,
  location: locationSchema.optional(),
  seat: z.object({
    enabled: z.boolean(),
  }),
  fields: z.array(fieldSchema).optional(),
  information: z.array(informationBlockSchema).optional(),
});

export const validateExamReservationSettings = (
  config: Partial<ExamV3ExamReservationConfiguration>
) => {
  return examReservationSettingsSchema.safeParse(config);
};

export const validateExamReservationSettingsAsync = async (
  config: Partial<ExamV3ExamReservationConfiguration>
) => {
  return examReservationSettingsSchema.safeParseAsync(config);
};
